const ccbMemberRoutes = [
  {
    path: '/ccbMember',
    name: '联合会员专区',
    component: () => import('@/pages/ccbMember/index.vue')
  },
  {
    path: '/ccbMember/rights',
    name: '联合会员专区',
    component: () => import('@/pages/ccbMember/rights.vue')
  },
  {
    path: '/ccbMember/addRegistrationForm',
    name: '医生加号',
    component: () => import('@/pages/ccbMember/addRegistration/form.vue')
  },
  {
    path: '/ccbMember/addRegistrationRecord',
    name: '加号记录',
    component: () => import('@/pages/ccbMember/addRegistration/record.vue')
  },
  {
    path: '/ccbMember/addRegistrationDetail',
    name: '加号详情',
    component: () => import('@/pages/ccbMember/addRegistration/detail.vue')
  },
  {
    path: '/ccbMember/referralForm',
    name: '转诊记录',
    component: () => import('@/pages/ccbMember/referral/form.vue')
  },
  {
    path: '/ccbMember/referralRecord',
    name: '转诊记录',
    component: () => import('@/pages/ccbMember/referral/record.vue')
  },
  {
    path: '/ccbMember/referralDetail',
    name: '转诊记录',
    component: () => import('@/pages/ccbMember/referral/detail.vue')
  },
  {
    path: '/ccbMember/articleList',
    name: '健康百科',
    component: () => import('@/pages/ccbMember/article-list.vue')
  },
  {
    path: '/ccbMember/articleDetail',
    name: '健康百科',
    component: () => import('@/pages/ccbMember/article-detail.vue')
  },
  {
    path: '/ccbMember/examinationList',
    name: '建行联合会员专属套餐',
    component: () => import('@/pages/ccbMember/examination-list.vue')
  },
  {
    path: '/ccbMember/protocol',
    name: '建行联合会员信息授权书',
    component: () => import('@/pages/ccbMember/protocol.vue')
  },
]
export default ccbMemberRoutes
